import { Container, Grid, Skeleton, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import useTrackPageView from '../../../helpers/hooks/use-track-page-view'
import SplashScreenGuard from '../../../router/guards/SplashScreenGuard'
import { UserContext } from '../../../stores/User/UserStore'
import CommonBackButton from '../../atoms/CommonBackButton/CommonBackButton'
//import { useLinkpointRepository } from '../../../repositories/LinkPoint/use-linkpoint-repository'
import { AppContext } from '../../../stores/App/AppStore'
import MarkdownContent from '../../atoms/MarkdownContent/MarkdownContent'
import { formatWithThousandCommas } from '../../../helpers/utils/common'
import moment from 'moment'
import { DatePatterns } from '../../../types/date-patterns'

//import styles from './LinkPointGuide.module.css'

const LinkPointGuidePage = () => {
    useTrackPageView(`Linkpoint Guide Page`)

    //const { retrieveLinkGuidePage, retrieveLinkPool } = useLinkpointRepository()
    const { state: userState } = useContext(UserContext)
    const { state: appState } = useContext(AppContext)

    useEffect(() => {
        //retrieveLinkGuidePage()
        if (!userState.linkpointPool?.balance) {
            //retrieveLinkPool()
        }
    }, [])

    if (!appState.pages.linkpointGuidePage) {
        return <Skeleton width={`400px`} height={`200px`} variant="rectangular" />
    }
    const linkpoints = userState.linkpointPool?.balance ? formatWithThousandCommas(Number(userState.linkpointPool?.balance)) : `NA`
    const expiryDate = moment(userState.linkpointPool?.expiryDate, DatePatterns.YEAR_MONTH_DATE_COMBINED).format(DatePatterns.FORMAL_DATE_MONTH_YEAR)
    const linkpointsHeader = `Linkpoints: ${linkpoints} LP`
    const linkpointExpiringText = `${linkpoints} Linkpoints will expire on ${expiryDate}`

    return <Container>
        <SplashScreenGuard>
            <>
                <CommonBackButton />
                <Grid>
                    <Typography variant='h3'>{linkpointsHeader}</Typography>
                    <Typography variant='body1'>{linkpointExpiringText}</Typography>
                    <MarkdownContent content={appState.pages.linkpointGuidePage} />
                </Grid>
            </>
        </SplashScreenGuard>
    </Container>
}

export default LinkPointGuidePage